/**
 * The live view of a purchase's browser, for a bank's check (3-D Secure).
 * Link in Bio and app-web draw it in the checkout sheet; the native app
 * shows Link in Bio's `/live-view` page, which draws only this, in a web
 * view. No other surface connects to the browser.
 */
export { LiveBrowserView } from "./view";
export { PAGE_VIEWPORT, isLiveViewHost } from "./cdp";
